import { render, staticRenderFns } from "./Wiper.vue?vue&type=template&id=d6af0b12&scoped=true"
import script from "./Wiper.vue?vue&type=script&lang=js"
export * from "./Wiper.vue?vue&type=script&lang=js"
import style0 from "./Wiper.vue?vue&type=style&index=0&id=d6af0b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6af0b12",
  null
  
)

export default component.exports